<template>
  <div class="general">

    <div class="general-info__top">
      <app-text-input
      class="drainage-name-input active"
      v-model="drainage.name"
      required
      :label="$ml.get('Name')"
    />
      <date-selector
        class="drainage-date"
        :label="$ml.get('Sampling Date')"  
        v-model="drainage.sampling_date"
      />
    </div>

    <div class="row">

      <div class="column">

        <p><b>{{ $ml.get(`GENERAL`) }}</b></p>

        <div class="column-flex">
          <app-text-input
            :label="$ml.get(`Drip volume`)"
            v-model="drainage.dripVolume"
            type="number"
            :hint="$store.getters['unit/getLabel']('mL')"
            min="0"
            required
            @input="setPercentage()"
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
          <app-text-input
            :label="$ml.get(`Drain volume`)"
            v-model="drainage.drainageVolume"
            type="number"
            :hint="$store.getters['unit/getLabel']('mL')"
            min="0"
            required
            @input="setPercentage()"
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
          
        </div>

        <template>
          <div v-if="drainage.drainagePercentage" id="drainage-percentage" :class="{error : drainage.drainagePercentage > 100}">
            <span>{{$ml.get(`Drainage percentage`)}}:</span> {{drainage.drainagePercentage.toFixed()}} %
            <div v-if="drainage.drainagePercentage > 100">
              {{$ml.get(`Drainage percentage must be less than 100% !`)}}
            </div>
          </div>
          <!-- % = (drip / drain) * 100 -->
        </template>
      </div>

      <div class="column">

        <p><b>{{ $ml.get(`DRIP DATA`) }}</b></p>

        <div class="column-flex">
          <app-text-input
            :label="$ml.get(`pH`)"
            v-model="drainage.dripDataPh"
            type="number"
            min="0"
            max="14"
            required
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
          <app-text-input
            :label="$ml.get(`EC`)"
            v-model="drainage.dripDataEc"
            type="number"
            min="0"
            required
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
          
        </div>

      </div>

      <div class="column">

        <p><b>{{ $ml.get(`DRAINAGE DATA`) }}</b></p>

        <div class="column-flex">
          <app-text-input
            :label="$ml.get(`pH`)"
            v-model="drainage.drainageDataPh"
            type="number"
            min="0"
            max="14"
            required
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
          <app-text-input
            :label="$ml.get(`EC`)"
            v-model="drainage.drainageDataEc"
            type="number"
            min="0"
            required
            :step="0.1"
            :digits-after-dot="1"
            class="drainage-input"
          />
        </div>

      </div>

    </div>


  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  props: {
    type: {
      default: 'number'
    }
  },
  computed: {
    ...mapGetters({
      drainage: 'drainage/data',
    })
  },
  methods: {
    save() {
      this.$emit('save');
    },

    setPercentage() {
      if(this.drainage.dripVolume > 0 && this.drainage.drainageVolume > 0)
        this.$store.commit('drainage/setDrainagePercentage', this.drainage.drainageVolume / this.drainage.dripVolume * 100)
      else
        this.$store.commit('drainage/setDrainagePercentage', 0)
    }
  }

}
</script>

<style lang="scss" scoped>
.general {
  .general-info__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .date-selector.dropdown {
      width: 33% !important;
    }
    .mx-datepicker-popup {
      left: 0 !important;
    }
  }
  .drainage-name-input {
    width: 33% !important;
    margin: 20px 0 15px 0 !important;
    padding-left: 5px;
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 8px 0;
    &:first-child {
      padding-top: 0;
    }
    .column {
      flex: 0 0 34%;
      border-right: 1px #e8e8e8 solid;
      &:last-child {
        border: 0;
      }
      p {
        width: 70%;
        margin: 12px auto 0;
        font-size: 14px;
        text-align: center;
      }

      .column-flex {
        display: flex;
        padding: 0 15px;

        

        .text-input {
          &:first-child {
            margin-right: 10px;
          }
          .input-label.h-no-sel.active.default {
            font-size: 12px !important;
            background: #fff;
          }
        }

      }
    }
  }
  .app-text-input {
    width: 70%;
    margin: 32px auto 0;
  }

    #drainage-percentage {
      font-size: 15px;
      margin-top: 25px;
      text-align: center;
      span {
        font-weight: bold;
        color: #000;
      }
      &.error {
        color: red
      }
    }
  }
</style>
